// import moment from 'moment'
const moment = require('moment-timezone');

moment.tz.setDefault('Europe/Moscow');

// формат указан в вики https://wiki.oooinex.ru/pages/viewpage.action?pageId=47743062
// хелп момента https://momentjs.com/docs/#/displaying/format/
const dateFmt = {
	humanDate: 'DD.MM.YYYY',
	humanMonth: 'MM.YYYY',
	humanTime: 'HH:mm',
	humanFull: 'DD.MM.YYYY HH:mm',
	humanFullSec: 'DD.MM.YYYY HH:mm:ss',
	server: 'YYYY-MM-DDTHH:mm:ssZ',
};

const dateUtil = {
	humanToIso(str) {
		return moment(str, dateFmt.humanFull, true).format(dateFmt.server);
	},
	isoToHuman(str) {
		return moment(str, dateFmt.server, true).format(dateFmt.humanFull);
	},
	isoToHumanDate(str, withTime) {
		const resultMoment = moment(str, dateFmt.server, true);

		if (!withTime) {
			//этот костыль для даты 1916.07.3 потому что она нормально не конвертится
			if (resultMoment._a[0] === 1916 && resultMoment._a[1] === 6 && resultMoment._a[2] === 3) {
				resultMoment.set({ h: 0, m: 1, s: 2 }).utc(true);
			} else {
				resultMoment.set({ h: 0, m: 0, s: 0 }).utc(true);
			}
		}

		return resultMoment.format(dateFmt.humanDate);
	},
	isoToHumanTime(str) {
		return moment(str, dateFmt.server, true).format(dateFmt.humanTime);
	},
	isoToHumanSec(str) {
		return moment(str, dateFmt.server, true).format(dateFmt.humanFullSec);
	},
	dateObjToToIso(dateObj) {
		return moment(dateObj).format(dateFmt.server);
	},
	dateObjToToHumanFullSec(dateObj) {
		return moment(dateObj).format(dateFmt.humanFullSec);
	},
	dateObjToHumanDate(dateObj) {
		return moment(dateObj).format(dateFmt.humanDate);
	},
	dateObjToHumanMonth(dateObj) {
		return moment(dateObj).format(dateFmt.humanMonth);
	},
	humanDateIsValid(str) {
		return moment(str, dateFmt.humanDate, true).isValid();
	},
	humanTimeIsValid(str) {
		return moment(str, dateFmt.humanTime, true).isValid();
	},
	isoUpdate(ISODateString, toSet) {
		let resultMoment;
		if (typeof ISODateString === 'string') {
			resultMoment = moment(ISODateString, dateFmt.server, true).set(toSet).format(dateFmt.server);
		} else {
			resultMoment = null;
		}

		return resultMoment;
	},
	isoUpdateHumanDate(ISODateString, humanStringToSet, toSetXtra, withTime) {
		let resultMoment;
		const arr = humanStringToSet.split('.');
		if (arr.length !== 3) {
			throw new Error('humanStringToSet должна быть ДД.ММ.ГГГГ', humanStringToSet);
		}
		const toSet = {
			date: arr[0],
			month: arr[1] - 1,
			year: arr[2],
			...toSetXtra,
		};
		if (typeof ISODateString === 'string') {
			resultMoment = moment(ISODateString, dateFmt.server, true);
		} else {
			// тут оффсет таймзоны берется текущий, потенциальный баг
			resultMoment = moment().startOf('day');
		}

		if (withTime === false) {
			resultMoment.set({ h: 0, m: 0, s: 0 });
			// Мы отправлем московкое вермя
			// Мы принимаем московское время
			// Московское время может быть с разным смещененим 01.12.1800 = + 2,5ч, 1.12.2020 = +3.00ч

			//resultMoment.set({h: 0, m: 0}).utcOffset('+03:00', true)
		}

		return resultMoment.set(toSet).format(dateFmt.server);
	},
	clearTimezoneHumanDate(date) {
		return moment(date, dateFmt.server, true).set({ h: 0, m: 0, s: 0 }).format(dateFmt.server);
	},
	isoGet(ISODateString, whatToGet) {
		// https://momentjs.com/docs/#/get-set/get/
		return moment(ISODateString, dateFmt.server, true).get(whatToGet);
	},
	getCurrentDate() {
		// здесь должно быть получение серверной даты
		return moment().toDate();
	},
	/**
	 * @param {Date} dateObj - дата, к которой нужно что-то добавить
	 * @param {number} qty - количество, которое нужно добавить (можно отрицательное)
	 * @param {string} unit - единица измерения, например "days", "months", "years" и т.д.
	 * @returns {Date}
	 */
	add(dateObj, qty, unit) {
		return moment(dateObj).add(qty, unit).toDate();
	},
};

export default dateUtil;
